/* eslint-disable import/no-cycle */
import { ref, computed, onUnmounted } from 'vue'
import { useMiniStore } from '@/miniStore'
import { Message } from '@qs/ui'
import { SIGN_STATUS_ENUM, SIGN_CHANNEL_ENUM, WITHHOLD_ENUM } from '../config'
import { openScanSignDialog } from '@/utils/dialogService.js'
import { useOrderAPI } from './useOrderLogic.js'

export { useWithdrawButton, useOrderAPI } from './useOrderLogic.js'

let scanSignDialog = null
let scanSignDialogScene = null

const getScanSignDialog = (sceneKey, onRefresh) => {
  // 懒加载单例；场景值变化（签约/续约切换）时重建，同场景重挂载时更新回调
  if (!scanSignDialog || scanSignDialogScene !== sceneKey) {
    scanSignDialog?.destroy?.()
    scanSignDialog = openScanSignDialog({
      onRefresh,
      sceneKey,
    })
    scanSignDialogScene = sceneKey
  } else {
    scanSignDialog.setOnRefresh(onRefresh)
  }
  return scanSignDialog
}

// 发起签署和下一步按钮
export function useSignButton(validateForm, onRefresh, sceneKey) {
  const miniStore = useMiniStore(sceneKey)
  const loading = ref(false)
  const waitScanState = [
    SIGN_STATUS_ENUM.PENDING_INITIATE,
    SIGN_STATUS_ENUM.PENDING_APPROVAL,
    SIGN_STATUS_ENUM.WECHAT_QR_PENDING_SCAN,
    SIGN_STATUS_ENUM.ALIPAY_QR_PENDING_SCAN,
    SIGN_STATUS_ENUM.PENDING_SIGN,
  ]

  const waitScanQrCode = [
    SIGN_STATUS_ENUM.WECHAT_QR_PENDING_SCAN,
    SIGN_STATUS_ENUM.ALIPAY_QR_PENDING_SCAN,
    SIGN_STATUS_ENUM.PENDING_SIGN,
  ]

  const label = computed(() => {
    const { flowState, signChannel, isWithhold } = miniStore.state.data.step1 || {}
    if (flowState === SIGN_STATUS_ENUM.SIGN_COMPLETED
      || (isWithhold === WITHHOLD_ENUM.CLOSE && signChannel === SIGN_CHANNEL_ENUM.OFFLINE)
    ) {
      return '下一步'
    } else if (waitScanQrCode.includes(flowState)) { // 其实应该是扫码签约 文案先处理成发起签署
      return '下一步'
    } else if (flowState === SIGN_STATUS_ENUM.PENDING_APPROVAL) {
      return '刷新审批状态'
    } else if (flowState === SIGN_STATUS_ENUM.PENDING_INITIATE) {
      return '发起签署'
    }
    return ''
  })

  const handler = async (cb) => {
    const { flowState, signChannel, isWithhold } = miniStore.state.data.step1 || {}
    const { isRenew } = miniStore.state.data.global || {}
    const { genQrCode, queryOrderStatus, submitSignContract } = useOrderAPI({
      isRenew,
      sceneKey,
    })
    if (flowState === SIGN_STATUS_ENUM.PENDING_APPROVAL) {
      loading.value = true
      await queryOrderStatus()
      loading.value = false
      if (miniStore.state.data.step1?.flowState === 0) {
        window.location.reload()
      }
      return
    }

    const isValid = await validateForm()
    if (isValid) {
      loading.value = true

      try {
        if (waitScanState.includes(flowState)
          && (signChannel === SIGN_CHANNEL_ENUM.ONLINE || isWithhold === WITHHOLD_ENUM.OPEN)
        ) {
          const requestMethod = flowState === SIGN_STATUS_ENUM.PENDING_INITIATE
            ? genQrCode : queryOrderStatus

          // 获取二维码
          const { code, data } = await requestMethod()

          loading.value = false

          if (code === 1) {
            cb?.()
            if (data.flowState === SIGN_STATUS_ENUM.PENDING_INITIATE) {
              window.location.reload()
            }

            if (data.flowState === SIGN_STATUS_ENUM.PENDING_APPROVAL) {
              Message.info('签署审批中，可联系钉钉审批人及时处理')
            }

            if (data.flowState !== SIGN_STATUS_ENUM.PENDING_APPROVAL
                && data.flowState !== SIGN_STATUS_ENUM.SIGN_COMPLETED) {
              Message.info('需司机扫码完成合同签署后重试')
              getScanSignDialog(sceneKey, onRefresh).open({
                signType: 'BOTH',
                orderId: miniStore.state.data?.global?.orderId,
                spId: miniStore.state.data?.step1?.spId,
                licenceNo: miniStore.state.data?.step1.licenceNo,
                hasAlipay: data.hasAlipay,
                qrCodeInfo: {
                  flowState: data.flowState,
                  weixinQrCode: data.signQrCode?.qrCode,
                  alipayQrCode: data.alipayQrCode?.qrCode,
                  plateNo: data.flowState === SIGN_STATUS_ENUM.ALIPAY_QR_PENDING_SCAN
                    ? data.alipayQrCode?.plateNo : data.signQrCode?.plateNo,
                },
              })
            }
          }
        } else {
          submitSignContract(() => {
            loading.value = false
          })
        }
      } finally {
        loading.value = false
      }
    }
  }

  onUnmounted(() => {
    scanSignDialog?.destroy?.()
    scanSignDialog = null
    scanSignDialogScene = null
  })

  return {
    label,
    handler,
    loading,
  }
}
